import React from "react";
import { bulbIcon } from "../../../utils/images";
import commonContext from "../../../context/common";

function VehicleInfoHeader() {
    const { base } = React.useContext(commonContext);
    return (
        <>
            <h1 className="openSans-Reg text-black my-5 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                {base == "zd-10-seconds" || base == "dd-al"
                    ? "Bring home the car of your dreams!"
                    : ""}
                {base == "qm-10-seconds" ? "Vehicle Details" : ""}
            </h1>
            <div className="bg-light-yellow text-grey-darkest openSans-Reg py-2 px-4 mb-8 text-sm rounded inline-flex items-start md:items-center">
                <img
                    src={bulbIcon}
                    className="mr-3"
                    title="Information icon"
                    alt="Information icon"
                />
                <span>
                    {base == "zd-10-seconds" || base == "dd-al"
                        ? "Keep your dealer invoice handy as we require details of the dealer offered price and other discounts, if applicable, to  process your loan."
                        : ""}
                    {base == "qm-10-seconds"
                        ? "Your existing loan no. and vehicle details on which this Top Up Loan is being granted is as listed below:"
                        : ""}
                </span>
            </div>
        </>
    );
}

export default VehicleInfoHeader;
